import React, { Component } from 'react'
import { CardElement } from 'react-stripe-elements'
import './CreditCard.css'

// https://stripe.com/docs/recipes/elements-react
class CreditCard extends Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }

  render() {
    // https://stripe.com/docs/stripe-js/reference#element-options
    let baseStyle = this.props.context.theme === 'dark' ?
      {
        color: '#fff',
        fontSize: '14px',
        fontSmoothing: 'antialiased',
        '::placeholder': {
          color: '#999',
        },
      } :
      {
        color: '#333',
        fontSize: '14px',
        fontSmoothing: 'antialiased',
        '::placeholder': {
          color: '#999',
        },
      }

    let invalidStyle = {
      color: '#e54',
    }

    let completeStyle = {
      // color: '#1b9'
    }

    return (
      /* https://github.com/stripe/react-stripe-elements#elements */
      <CardElement
        style={{base: baseStyle, invalid: invalidStyle, complete: completeStyle}}
        className='w_cc'
        hidePostalCode={true}
        iconStyle='solid'
      />
    )
  }

}

export default CreditCard
